import React from 'react';
import ErrorBanner from '@avtechsoftware/react-component-library/src/components/common/ErrorBanner';
import moment from 'moment';
import ProgressSpinner from '@avtechsoftware/react-component-library/src/components/common/ProgressSpinner';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle, faCircle } from '@fortawesome/pro-solid-svg-icons';
import OrderDateRange from '../../orders/OrdersList/OrderStatusFactory/OrdersListDateRange';
import envConfig from '../../../envConfig';
import CrmQuote from '../../../classes/CrmQuote';
import { generateResourceURL } from '../../../utility/orderAndQuoteUtil';
import RaaAuthenticatedRemoteService from '../../../utility/RaaAuthenticatedRemoteService';

class QuotesList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dataLoading: true,
      error: false,
      quotes: [],
    };
    this.handleRowClick = this.handleRowClick.bind(this);
    this.handleDismissError = this.handleDismissError.bind(this);
    this.handleTimeRangeUpdate = this.handleTimeRangeUpdate.bind(this);
    this.getQuotes = this.getQuotes.bind(this);
  }

  componentDidMount() {
    this.getQuotes(moment().unix() - 7889229, moment().unix());
  }

  getQuotes(start, end) {
    this.setState({ dataLoading: true });

    RaaAuthenticatedRemoteService.globalInstance().get(`${envConfig.apiUrl}/api/v1/quotes/?startDate=${start}&endDate=${end}`)
      .then((response) => {
        this.setState({
          quotes: response.quotesList.map((quote) => new CrmQuote(
            quote.id,
            quote.status,
            quote.createdAt,
            quote.grandTotal,
            quote.tax,
            quote.shippingAddress,
            quote.billingAddress,
            quote.productSpecialist,
            quote.quoteLineItemList,
            quote.expiresAt,
            quote.shippingCost,
            quote.shippingCarrier,
            quote.shippingMethod,
            quote.currency,
            quote.crmOrgId,
          )),
        });
      }).catch(() => {
        this.setState({ error: true });
      })
      .finally(() => {
        this.setState({ dataLoading: false });
      });
  }

  handleTimeRangeUpdate(e) {
    const { value } = e.target;
    const startOfYear = moment().tz('America/New_York').startOf('year').unix();
    let startTimestamp = moment().unix() - 7889229;
    let endTimestamp = moment().unix();
    switch (parseInt(value, 10)) {
      case OrderDateRange.THIS_YEAR:
        startTimestamp = startOfYear;
        break;
      case OrderDateRange.LAST_YEAR:
        startTimestamp = moment.unix(startOfYear).subtract(1, 'years').unix();
        endTimestamp = startOfYear;
        break;
      case OrderDateRange.TWO_YEARS_AGO:
        startTimestamp = moment.unix(startOfYear).subtract(2, 'years').unix();
        endTimestamp = moment.unix(startOfYear).subtract(1, 'years').unix();
        break;
      case OrderDateRange.THREE_YEARS_AGO:
        startTimestamp = moment.unix(startOfYear).subtract(3, 'years').unix();
        endTimestamp = moment.unix(startOfYear).subtract(2, 'years').unix();
        break;
      case OrderDateRange.FOUR_YEARS_AGO:
        startTimestamp = moment.unix(startOfYear).subtract(4, 'years').unix();
        endTimestamp = moment.unix(startOfYear).subtract(3, 'years').unix();
        break;
      case OrderDateRange.FIVE_YEARS_AGO:
        startTimestamp = moment.unix(startOfYear).subtract(5, 'years').unix();
        endTimestamp = moment.unix(startOfYear).subtract(4, 'years').unix();
        break;
      default:
        break;
    }
    this.getQuotes(startTimestamp, endTimestamp);
  }

  // eslint-disable-next-line class-methods-use-this
  handleRowClick(orderNumber, orgId) {
    const { history } = this.props;
    history.push(`/s/quotes/details/QUO-${generateResourceURL(orderNumber, orgId)}`);
  }

  handleDismissError() {
    this.setState({ error: false });
  }

  /* istanbul ignore next */
  render() {
    const { dataLoading, error, quotes } = this.state;
    return (
      <div className="container-fluid">
        {error && (
          <div className="row">
            <div className="col">
              <ErrorBanner onCloseError={this.handleDismissError}>
                Unexpected Error retrieving quotes.
              </ErrorBanner>
            </div>
          </div>
        )}
        <div className="row">
          <div className="col-auto">
            <select className="form-control" onChange={this.handleTimeRangeUpdate}>
              <option value={OrderDateRange.LAST_THREE_MONTHS}>Last 3 Months</option>
              <option value={OrderDateRange.THIS_YEAR}>{moment().year()}</option>
              <option value={OrderDateRange.LAST_YEAR}>{moment().year() - 1}</option>
              <option value={OrderDateRange.TWO_YEARS_AGO}>{moment().year() - 2}</option>
              <option value={OrderDateRange.THREE_YEARS_AGO}>{moment().year() - 3}</option>
              <option value={OrderDateRange.FOUR_YEARS_AGO}>{moment().year() - 4}</option>
              <option value={OrderDateRange.FIVE_YEARS_AGO}>{moment().year() - 5}</option>
            </select>
          </div>
        </div>
        <table className="table table-sm table-striped mt-3 table-hover ">
          <thead>
            <tr>
              <th>Created</th>
              <th>Quote Number</th>
              <th>Items</th>
              <th>Total</th>
              <th>Status</th>
            </tr>
          </thead>
          {!dataLoading
                && (
                <tbody>
                  {quotes.map((quote, index) => (
                    <tr style={{ cursor: 'pointer' }} key={`${quote.id}-${index}`} onClick={() => this.handleRowClick(quote.id, quote.crmOrgId)}>
                      <td>{moment.unix(quote.createdAt).format('MMM DD, YYYY')}</td>
                      <td>{quote.quoteNumber}</td>
                      <td>{quote.quantity}</td>
                      <td>{quote.total}</td>
                      <td>
                        <span>
                          {quote.statusType && quote.statusType !== 'Closed'
                            ? <FontAwesomeIcon icon={faCircle} className="text-primary" />
                            : <FontAwesomeIcon icon={faTimesCircle} className="text-muted" />}
                          {' '}
                          {quote.statusType}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
                )}
        </table>
        {dataLoading && (
          <div className="row d-flex justify-content-center mt-5">
            <div><ProgressSpinner progressText="Loading..." /></div>
          </div>
        )}
      </div>
    );
  }
}

QuotesList.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export { QuotesList };
export default withRouter(QuotesList);
